"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var CalendarEditOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M874.667 853.333a42.667 42.667 0 110 85.334H149.333a42.667 42.667 0 010-85.334h725.334zM731.669 124.821l90.518 90.518a85.333 85.333 0 010 120.661L378.539 779.648a85.333 85.333 0 01-60.822 25.003l-111.082-.64a64 64 0 01-63.638-63.638l-.64-111.082a85.333 85.333 0 0125.003-60.822L610.987 124.8a85.333 85.333 0 01120.682 0v.021zm-60.309 60.331L227.69 628.8l.513 89.984 90.005.533L761.813 275.67l-90.453-90.496v-.021z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
CalendarEditOutlined.displayName = "CalendarEditOutlined";
var _default = exports["default"] = CalendarEditOutlined;